import { type ComponentPropsWithRef } from "react";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./InputLabelRight.styled";
import { Typography } from "../Typography";

export type InputLabelRightProps = Omit<
  ComponentPropsWithRef<"label">,
  "htmlFor" | "style" | "className"
> & {
  label?: string;
};

function InputLabelRight(props: InputLabelRightProps) {
  const { label, children, ...labelProps } = props;

  const { tokens } = useDesignTokens();
  const { inputLabelRight } = tokens;

  return (
    <S.Container {...labelProps}>
      <S.InputWrapper $label={label}>{children}</S.InputWrapper>

      {label && (
        <S.LabelWrapper>
          <Typography
            component="span"
            color="inherit"
            variant={inputLabelRight.label.typography.variant}
            fontFamily={inputLabelRight.label.typography.fontFamily}
          >
            {label}
          </Typography>
        </S.LabelWrapper>
      )}
    </S.Container>
  );
}

export default InputLabelRight;
